module.exports = __webpack_public_path__ + "img/bgEducationCertificate.7101b0c5.png";